module.exports = __webpack_public_path__ + "fonts/roboto-condensed-v19-latin-ext_latin-700.6449741.ttf";